
import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper, 
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Autocomplete,
  TextField,
  Divider
} from '@mui/material';
import { Col, Row, message} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
  
// import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import './dashboard.module.scss'
import { Divide } from 'lucide-react';
import axios from 'axios';
import { colors } from './colors';

import Highcharts from 'highcharts/highstock'


const CoverageTrends = (props) => {
  const [selectedEntities, setSelectedEntities] = useState(['AAPL', 'GOOGL', 'MSFT', 'TSLA']);
  const [granularity, setGranularity] = useState('');
  const [level, setLevel] = useState({label:'Ticker Level',value:'ticker'});
  const [aggregationMethod, setAggregationMethod] = useState('');
  const [loader, setloader] = useState(false)
  const [CoverageData, setCoverageData] = useState(null)

  function convertQuarterToDate(quarterStr) {
      const [yearStr, qStr] = quarterStr.split("Q");
      const year = parseInt(yearStr, 10);
      let month = 0;

      switch (qStr) {
        case "1":
          month = 3; // January
          break;
        case "2":
          month = 6; // April
          break;
        case "3":
          month = 9; // July
          break;
        case "4":
          month = 12; // October
          break;
        default:
          console.warn(`Unknown quarter: ${quarterStr}`);
      }

      return new Date(year, month).getTime();
    }

  const GenerateLevelsChart = () => {
        Highcharts.setOptions({
              lang:{
                rangeSelectorZoom: 'Select time period',
              }
                });
        Highcharts.stockChart('providers-coverage-lineGraph', {
                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 100
                            },
                            chartOptions: {
                                legend: {
                                    enabled: false
                                }
                            }
                        }]
                    },
                    // To insert custom Screen (Modal with date , point and index to add up)
                    exporting: false,
                    // colors: colors,
                    tooltip: {
                        valueDecimals: 2
                    },
                    colors:colors,
                    series: [{
                        name: `Number of Unique ${level.value == "ticker"?"Tickers":"Entites"} Covered`,
                        id: 'SMLevel',
                        data: CoverageData,
                        // color: '#FFEB00',
                        zIndex: 50,
                        turboThreshold: 100000,
                        showInLegend: false,
                        // type:'area',
                        tooltip: {
                            valueDecimals: 0
                        },
                        cursor: 'pointer',
                        fillColor: {
                            linearGradient: {
                                x1: 1,
                                y1: 0,
                                x2: 0,
                                y2: 2
                            },
                            stops: [
                                [0, '#0F5B5D'],
                                [1, 'transparent'],
                                [2, '#0F5B5D'],
                            ]
                        }
                    }],
                    title: {
                        style: {
                            color: '#DDD',
                            fontWeight: 'Bold',
                            fontSize: '20px',
                            letterSpacing: '1.2px'
                        },
                        text: ""
                    },
                    chart: {
                        plotBorderWidth: 0,
                        backgroundColor: 'transparent',
                        height: 300,
                        style: {
                            fontFamily: 'inherit'
                        },
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        enabled: true,
                        itemStyle: { color: "#2a5b93" },
                        itemHoverStyle: {
                            color: '#2a5b93'
                        },
                        maxHeight: 55,
                        navigation: {
                            activeColor: '#CCC',
                            animation: true,
                            arrowSize: 10,
                            inactiveColor: '#3E576F',
                            style: {
                                //fontWeight: 'bold',
                                color: '#fff',
                                fontSize: '10px'
                            }
                        }
                    },
                    scrollbar: {
                        enabled: false,
                        barBackgroundColor: '#2567af',
                        barBorderWidth: 0,
                        buttonBackgroundColor: '#204584',
                        buttonArrowColor: '#9ce4f5',
                        buttonBorderColor: "#225da4",
                        rifleColor: '9ce4f5',
                        trackBackgroundColor: '#203b6d',
                        trackBorderWidth: 0,
                        trackBorderColor: '#203b6d'
                    },
                    xAxis: {
                        // lineColor: '#2c5687',
                        // tickColor: '#2c5687',
                        lineColor: 'transparent',
                        tickColor: 'transparent',
                        gridLineColor: 'transparent',
                        // alternateGridColor: 'rgba(15, 91, 93, 0.1)',
                        crosshair: true,
                        ordinal: false,
                        allowDecimals: false,
                        // type: 'datetime',
                        // minRange: 24 * 3600 * 1000, // 1 day
                        labels: {
                            style: {
                                color: 'var(--textPrimary)',
                                fontSize: '11px'
                            }
                        }
                    },
                    yAxis: {
                        lineColor: '#2c5687',
                        color: '#2c5687',
                        // gridLineColor: '#244c8c',
                        gridLineColor: 'transparent',
                        gridLineWidth: 0,
                        gridLineDashStyle: "shortdot",
                        labels: {
                            style: {
                                color: 'var(--textPrimary)',
                                fontSize: '11px'
                            }
                        }
                    },
                    navigator: {
                        height: 20,
                        handles: {
                            backgroundColor: 'var(--appBackground)',
                            borderColor: 'var(--textPrimary)'
                        },
                        maskFill: 'rgba(136, 119, 119, 0.2)',
                        outlineColor: 'transparent',
                        outlineWidth: 1,
                        xAxis: {
                            ordinal: false,
                            gridLineWidth: 0,
                            // lineColor: '#2c5687',
                            // tickColor: '#2c5687',
                            labels: {
                                style: {
                                    color: 'var(--textPrimary)',
                                }
                            }
                        }
                    },
        
                    rangeSelector: {
                        inputEnabled: false,
                        buttonTheme: { // styles for the buttons
                        fill: 'var(--dark5)',
                        stroke: 'none',
                        'stroke-width': 0,
                        r: 8,
                        style: {
                            color: 'var(--textPrimary)',
                        },
                        states: {
                            hover: {
                                fill: '#ffeb00',
                                style: {
                                    color: '#000'
                                }
                            },
                            select: {
                                fill: '#FFEB00',
                                style: {
                                    color: '#000'
                                }
                            }
                            // disabled: { ... }
                        }
                    },
                    },
                });
      }


  const GetCoverageData = () =>{
    setloader(true)
    axios({
      method:'POST',
      url:'/api/dataset_coverage',
      data:{
        "type":level?.value,
        "period":granularity?.value,
        "dataset_id":props?.SelectedProviderDataset?.value,
        "client_id":props?.SelectedProvider?.value
      }
    }).then(res=>{
      setCoverageData(
        res.data
          .map((item) => {
            let timestamp;
            if (String(item.date).includes("Q")) {
              timestamp = convertQuarterToDate(item.date);              
            } else if (String(item.date).length >4) {
              timestamp = new Date(item.date).getTime();
            } else {
              timestamp = new Date(`${item.date}-01-01`).getTime();
            }
            return [timestamp, item.coverage];
          })
          .sort((a, b) => a[0] - b[0])
      )
      setloader(false)

    }).catch((err)=>{
        console.log("err");
        console.log(err);
        message.error(err?.response?.data?.error,3)
        setloader(false)

    })
  }

  useEffect(()=>{
    CoverageData?.length&&GenerateLevelsChart()
  },[CoverageData])

  useEffect(()=>{
    if (level?.value && granularity?.value){
      setCoverageData(null)
      GetCoverageData()
    }
  },[level?.value,granularity?.value])

  
  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
        <Box>
          <Typography variant="h2" sx={{ mb: 0.5, color: 'var(--textPrimary)' }}>
            Coverage Trends Analysis
          </Typography>
          <Typography variant="body1" sx={{ color: 'var(--textPrimary)' }}>
            Historical coverage dynamics and entity breadth over time
          </Typography>
        </Box>
        {/* <Button variant="contained">
          Export Chart
        </Button> */}
      </Box>
      <Box>
          <Row gutter={[18,18]} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', margin:'0px 0px 30px 0px'}}>
            <Col span={6} style={{padding:'0px'}}>
              <Autocomplete
                  className="data-select"
                  size='small'
                  disablePortal
                  id="disable-clearable"
                  disableClearable
                  fullWidth
                  value={level}
                  defaultValue={level}
                  onChange={(e,v)=>{setLevel(v)}}
                  options={
                    [{'label':'Ticker level',value:'ticker'},
                    {'label':'Entity/Marchant level',value:'entity'}]
                  }
                  renderInput={(params) => <TextField {...params} label='Choose a Dataset' />}
              />
            </Col>
            {level&&<Col span={6}>
              <Autocomplete
                  className="data-select"
                  size='small'
                  disablePortal
                  id="disable-clearable"
                  disableClearable
                  fullWidth
                  value={granularity}
                  defaultValue={granularity}
                  onChange={(e,v)=>{setGranularity(v)}}
                  getOptionDisabled={(option) => {
                          // Disable options based on the frequency value
                          if (props?.SelectedProviderDataset?.frequency == 'Weekly' && (option?.value === 'daily')) {
                              return true;
                              }
                          if (props?.SelectedProviderDataset?.frequency == 'Monthly' && (option?.value === 'daily' || option?.value === 'weekly')) {
                              return true;
                          }
                          if (props?.SelectedProviderDataset?.frequency == 'Quarterly' && (option?.value === 'daily'|| option?.value === 'weekly'|| option?.value === 'monthly')) {
                              return true;
                          }
                          if (props?.SelectedProviderDataset?.frequency == 'Biannually' && (option?.value === 'daily'|| option?.value === 'weekly'|| option?.value === 'monthly' || option?.value === 'quarterly')) {
                              return true;
                          }
                          if (props?.SelectedProviderDataset?.frequency == 'Yearly' && (option?.value === 'daily'|| option?.value === 'weekly'|| option?.value === 'monthly' || option?.value === 'quarterly' || option?.value === 'biannually')) {
                              return true;
                          }
                          // Add more conditions based on the frequency value as needed
                          return false;
                      }}
                  options={
                    [{'label':'Daily',value:'daily'},
                    {'label':'Weekly',value:'weekly'},
                    {'label':'Monthly',value:'monthly'},
                    {'label':'Quarterly',value:'quarterly'},
                    {'label':'Yearly',value:'yearly'},
                    ]
                  }
                  renderInput={(params) => <TextField {...params} label='Choose a Time Period' />}
              />
            </Col>}
            {/* {granularity&&granularity?.value != 'daily'&&<Col span={6}>
                  <Autocomplete
                      className="data-select"
                      size='small'
                      disablePortal
                      id="disable-clearable"
                      disableClearable
                      fullWidth
                      value={aggregationMethod}
                      defaultValue={aggregationMethod}
                      onChange={(e,v)=>{setAggregationMethod(v)}}
                      options={
                        [{'label':'Sum',value:'sum'},
                        {'label':'Mean',value:'mean'},
                        {'label':'Min',value:'min'},
                        {'label':'Max',value:'max'},
                        {'label':'Last Value',value:'last_value'},
                        {'label':'First Value',value:'first_value'},
                        ]
                      }
                      renderInput={(params) => <TextField {...params} label='Choose a Agg Period' />}
                  />
            </Col>} */}
          </Row>
      </Box>

      {/* Chart Section */}
      <Paper sx={{ border: '1px solid #334155' }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 3 }}>
            <Typography variant="h2" sx={{ mb: 0.5, fontSize: '1.5rem', fontWeight: 600, color: 'var(--textPrimary)' }}>
              Entity Coverage Over Time
            </Typography>
        </Box> */}

        <Row>
          <Col span={24}>
              {/* {CoverageData.length > 0 ?
                <div id='providers-coverage-lineGraph'></div>:
                <div></div>
              } */}
              
              {CoverageData?<div id="providers-coverage-lineGraph"></div>:<></>}
              { loader&&
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', mb: 3, p: 3 }}>
                      <Typography variant='h3'  >Loading Chat....</Typography>
                  </Box>
              }
              {!granularity?.value&&
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', mb: 3, p: 3 }}>
                  <Typography variant='h3'>Please Select the Time period to see the Coverage</Typography>
                </Box>
              }
          </Col>
        </Row>
      </Paper>
    </Box>
  );
};

export default CoverageTrends;